import { chevronDown } from "@simplybusiness/icons";
import { Button, Drawer, Icon, TextOrHTML } from "@simplybusiness/mobius";
import { useState } from "react";
import type { HelpLinkProps } from "..";

export const HelpLink = ({
  headline,
  label,
  text,
  onOpenDrawer,
}: HelpLinkProps) => {
  const [open, setOpen] = useState(false);

  const openDrawer = () => {
    if (onOpenDrawer) {
      onOpenDrawer();
    }
    setOpen(true);
  };

  const closeDrawer = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        className="mobius-question__help-link"
        onClick={openDrawer}
        variant="link"
        size="sm"
      >
        <Icon fixedWidth icon={chevronDown} size="sm" />
        <span>{label}</span>
      </Button>
      <Drawer
        className="mobius-question__help-link-drawer"
        isOpen={open}
        direction="right"
        closeLabel="Close"
        onClose={closeDrawer}
      >
        <Drawer.Header>{headline}</Drawer.Header>
        <Drawer.Content>
          <TextOrHTML text={text} htmlElementType="div" />
        </Drawer.Content>
      </Drawer>
    </>
  );
};
